import React, { useState } from 'react';
import { DatePicker, Button, Space, Row } from 'antd';
import { Spacing } from 'works/legacy/lib/style-helper';
import type { Moment } from '@common/services/datetime';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';

type ChangeValue = (Moment | string | null)[] | null;

export const DateRangeFilter = ({
  onChange,
  onSearch,
  defaultValue = [],
  autoFocus,
}: {
  onChange?: (search: ChangeValue) => void;
  onSearch?: (search: ChangeValue) => void;
  // TODO(WORK-5920): accept and emit DatetimeType instead of moment here
  defaultValue?: Moment[];
  autoFocus: boolean;
}) => {
  const [queryString, setQueryString] = useState<ChangeValue>(defaultValue);

  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: Spacing.baseSpacing / 2,
        }}
      >
        <RangePicker
          autoFocus={autoFocus}
          defaultValue={[defaultValue[0], defaultValue[1]]}
          onChange={(value) => {
            setQueryString(value);
            onChange?.(value);
          }}
          format={dateFormat}
          placeholder={['From date', 'To date']}
        />
      </Space>
      <Row justify="end">
        <Button
          type="primary"
          onClick={() => {
            onSearch?.(queryString);
            setQueryString(null);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Apply
        </Button>
      </Row>
    </>
  );
};
